module.exports = __webpack_public_path__ + "static/media/next@2x.8c82d21b.png";